// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2J0yN","rootMobile":"styles_rootMobile__Zm034"};